module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "vux-button-tab-item",
    class: _vm.classes,
    style: (_vm.style),
    attrs: {
      "href": "javascript:"
    },
    on: {
      "click": _vm.onItemClick
    }
  }, [_vm._t("default")], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0925e018"}!./~/vux-loader/src/template-loader.js!./~/vue-loader/lib/selector.js?type=template&index=0!./~/vux/src/components/button-tab/button-tab-item.vue
// module id = 465
// module chunks = 4